var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2d3c6b;}.b{fill:#0da750;}.c{fill:#6dcef8;}.d{fill:#c3e678;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-875 -2105)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.706,2.5H-73.7l-.437-.435c-.516-.516-.97-.981-1.388-1.423C-75.852.3-76.178-.044-76.5-.392V-115.609l.024-.026.25-.269.045-.048c.668-.718,1.367-1.442,2.078-2.152a85.532,85.532,0,0,1,12.58-10.379,84.932,84.932,0,0,1,14.437-7.837,84.556,84.556,0,0,1,15.955-4.953A85.662,85.662,0,0,1-14-143a85.647,85.647,0,0,1,17.273,1.756,84.627,84.627,0,0,1,16.075,5.035,85.073,85.073,0,0,1,14.526,7.963A85.617,85.617,0,0,1,46.5-117.706V1.706l-.132.132-.005.006-.008.008L46.1,2.1l-.4.4Z",
    transform: "translate(974 2248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.789,182.536a84.738,84.738,0,0,1-22.565,52.013l-.049.048c-.676.729-1.369,1.448-2.074,2.153a84.948,84.948,0,0,1-118.735,1.426q-.761-.724-1.5-1.465l99.079-99.147.451-.45Zm0,0",
    transform: "translate(825.005 2013.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.522,190.7a20.584,20.584,0,0,1-35.547-16.517L24.89,195.226l-.017.017c-.468-.468-.93-.94-1.389-1.423a84.93,84.93,0,0,1-.7-116.52l.3-.372,1.778-1.812L45.6,95.836A20.568,20.568,0,1,0,64.322,114.57l20.63,20.642.039.038L63.868,156.328A20.569,20.569,0,0,1,81.522,190.7Zm0,0",
    transform: "translate(875 2054.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M336.97,131.218q0,2.986-.205,5.921a84.609,84.609,0,0,1-22.581,51.971l-.049.048-2.211,2.21-20.668-20.68a20.565,20.565,0,1,0-18.725-18.733l-20.668-20.677,21.126-21.082-.118.014A20.569,20.569,0,1,1,290.891,92.2c0,.045-.006.095-.014.139l.528-.526,20.779-20.59,3.253,3.476A84.618,84.618,0,0,1,336.97,131.218Zm0,0",
    transform: "translate(708.03 2058.781)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.5bf02aec18e911ee0523254cb58e8c0d.svg";
export { ForwardRef as ReactComponent };